import * as constants from '../constants';
import { SentToAnalytics } from './base';
export interface CategoryExpand extends SentToAnalytics {
  type: constants.CATEGORY_EXPAND;
}

export interface CategoryCollapsed extends SentToAnalytics {
  type: constants.CATEGORY_COLLAPSED;
}

export const categoryExpand = (categoryId: number, categoryName: string): CategoryExpand => {
  return {
    props: { categoryId, categoryName },
    type: constants.CATEGORY_EXPAND,
  };
};


export const categoryCollapsed = (categoryId: number, categoryName: string): CategoryCollapsed => {
  return {
    props: { categoryId, categoryName },
    type: constants.CATEGORY_COLLAPSED,
  };
};

export type CategoryActions = CategoryExpand | CategoryCollapsed;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/categories.ts